import React from "react";

// A tiny tag on a chat in the list: "AI draft" when the assistant has a reply waiting for you, "AI" while the
// assistant has the chat. Nothing when the assistant is off, or the chat is with your team.
const AiRowBadge = ({ badge }) => {
  if (!badge) return null;
  const draft = !!badge.has_draft;
  if (!draft && badge.ai_state !== "ai") return null;
  return (
    <span
      title={draft ? "The AI Assistant suggested a reply" : "The AI Assistant is handling this chat"}
      style={{
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: 0.4,
        color: "#fff",
        background: draft ? "#f59f00" : "#3b5bdb",
        borderRadius: 10,
        padding: "1px 7px",
        textTransform: "uppercase"
      }}
    >
      {draft ? "AI draft" : "AI"}
    </span>
  );
};

export default AiRowBadge;
